import styled from 'styled-components';

export const CardWrapper = styled.div`
  width: 100%;
  margin-top: 30px;
`;

export const UserProfilesWrapper = styled.div`
  background-color: ${props => props.color};
  display: flex;
  flex-direction: column;
  height: 100%;
`;



// WEBPACK FOOTER //
// ./src/routes/UsersProfiles/components/styles.js